import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildTrueFalseQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const answerText = escapePrintViewText(content.answer || '')
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const answerSectionHtml = answerText ? `<p>Answer:</p><p>${answerText}</p>` : ''

    return `${questionSectionHtml}${answerSectionHtml}`
}

export {buildTrueFalseQuestionPrintView}
